import {Contact} from '@hconnect/tuc-processes/types'
import {parsePhoneNumber} from '@hconnect/tuc-processes/utils/phoneNumberUtils'
import {useMemo} from 'react'
import {useSelector} from 'react-redux'

import {AppState} from '../../../../Root.store'
import {getUserProfile} from '../../../../UserProfile/UserProfile.selectors'

/**
 * Hook to build default contacts for order intake form initialization.
 * Merges persisted contact data with user profile data.
 * Priority: persistedContact (most recent) > user profile data
 *
 * @param persistedContact - Previously saved contact data for this job site
 * @returns Contacts object with orderPlacer and siteContact, or undefined if both are empty
 */
export const useOrderIntakeDefaultContacts = (persistedContact?: {
  orderPlacer?: Contact
  siteContact?: Contact
}): {orderPlacer?: Contact; siteContact?: Contact} | undefined => {
  const apiUser = useSelector((state: AppState) => getUserProfile(state).userProfile)

  return useMemo(() => {
    const orderPlacer: Contact | undefined = persistedContact?.orderPlacer
      ? persistedContact.orderPlacer
      : apiUser
        ? {
            name: apiUser.name ?? '',
            phoneNumber: parsePhoneNumber(apiUser.mobileNumber ?? '', apiUser.country ?? '')
          }
        : undefined

    const siteContact: Contact | undefined = persistedContact?.siteContact ?? orderPlacer

    // Return undefined if both are undefined, otherwise return the contacts object
    if (!orderPlacer && !siteContact) {
      return undefined
    }

    return {
      orderPlacer,
      siteContact
    }
  }, [persistedContact, apiUser])
}
